<template>
  <el-button>
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  data() {
    name: "ButtonPrimary";
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style scoped>
.el-button {
  background-color: #337ab7;
  border: 1px solid #2e6da4;
  color: white;
  font-size: 14px;
  line-height: 20px;
  padding: 6px 12px;
  margin: 0px;
}
.el-button:hover {
  background-color: #286090 !important;
  border: 1px solid #204d74 !important;
  color: white !important;
}
</style>
